import { useTranslation } from 'react-i18next';
import { Pin } from 'types';
import { formatToDate } from 'utils/formatToDate';

import { DocumentModel } from 'api/documents/documents.model';
import { BasicCard } from 'components/BasicCard';
import CardRow from 'components/CardRow';
import Detail from 'components/Detail';
import Map from 'components/Map';
import { extractCoordinatesFromProduct } from 'components/Map/utils';
import SectionTitle from 'components/SectionTitle';
import useCertificateHelper from 'hooks/useCertificateHelper';
import {
  ADDITIONAL_DETAILS,
  DEALER_DETAILS,
  CertificateDetailsModel,
  NESTED_DETAILS,
} from 'models/certificate.model';

import RelatedDocument from '../RelatedDocument';
import Template from '../Template';

const CarDealersShippingConfirmation = ({
  additionalDetails = {} as CertificateDetailsModel,
  ...document
}: DocumentModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();

  const { getLabel, getValueByLabel } = useCertificateHelper();

  const pins: Pin[] = [];

  if (additionalDetails[ADDITIONAL_DETAILS.DEALER]) {
    const coordinates = extractCoordinatesFromProduct(
      additionalDetails[ADDITIONAL_DETAILS.DEALER],
      DEALER_DETAILS.COORDINATES
    );

    if (coordinates) {
      pins.push({
        coordinates,
        iconPath: '/pin-blue.svg',
      });
    }
  }

  return (
    <Template
      document={{
        additionalDetails,
        ...document,
      }}
      rigthCard={
        <>
          <CardRow>
            <Detail
              label={getLabel(ADDITIONAL_DETAILS.SHIPPING_DATE)}
              value={formatToDate(additionalDetails[ADDITIONAL_DETAILS.SHIPPING_DATE])}
            />
            <Detail
              label={getLabel(NESTED_DETAILS.SALE_DATE)}
              value={formatToDate(additionalDetails[NESTED_DETAILS.SALE_DATE])}
            />
          </CardRow>
          <Detail
            label={t('document.dateOfPublication')}
            value={formatToDate(document.publicationDate)}
          />
          <Detail
            label={getLabel(NESTED_DETAILS.EVMODEL)}
            value={additionalDetails[NESTED_DETAILS.EVMODEL]}
          />
          <RelatedDocument
            relatedDocumentProductId={additionalDetails[NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER]}
          >
            <Detail
              label={getLabel(NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER)}
              value={additionalDetails[NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER]}
            />
          </RelatedDocument>
        </>
      }
    >
      <SectionTitle>{getLabel('carDealer')}</SectionTitle>
      <Map
        pins={pins}
        card={
          <BasicCard>
            <SectionTitle noMargin dividerMargin="1rem">
              {getLabel(ADDITIONAL_DETAILS.DEALER)}
            </SectionTitle>
            <Detail
              label={getLabel(DEALER_DETAILS.NAME)}
              value={getValueByLabel(
                DEALER_DETAILS.NAME,
                additionalDetails[ADDITIONAL_DETAILS.DEALER]
              )}
            />
            <Detail
              label={getLabel(DEALER_DETAILS.ADRESS)}
              value={getValueByLabel(
                DEALER_DETAILS.ADRESS,
                additionalDetails[ADDITIONAL_DETAILS.DEALER]
              )}
            />
            <Detail
              label={getLabel(DEALER_DETAILS.COUNTRY)}
              value={getValueByLabel(
                DEALER_DETAILS.COUNTRY,
                additionalDetails[ADDITIONAL_DETAILS.DEALER]
              )}
            />
            <Detail
              label={getLabel(DEALER_DETAILS.COORDINATES)}
              value={getValueByLabel(
                DEALER_DETAILS.COORDINATES,
                additionalDetails[ADDITIONAL_DETAILS.DEALER]
              )}
            />
          </BasicCard>
        }
      />
    </Template>
  );
};

export default CarDealersShippingConfirmation;
